
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/bank-transfers",
      function () {
        return require("private-next-pages/docs/errors/bank-transfers.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/bank-transfers"])
      });
    }
  